import axios from 'axios';

const _createConvoServiceHeaders = function () {
  return {
    withCredentials: true,
    headers: {
      'intuit_locale' : 'en_US',
      'intuit_originatingip' : '1.1.1.1',
      'Content-Type' : 'application/json',
      'Authorization' : `Intuit_APIKey intuit_token_type=IAM-Ticket,intuit_apkey_version=1.0,intuit_apikey=${process.env.REACT_APP_CONVERSATIONS_AWS_API_KEY},intuit_userid=${process.env.REACT_APP_CONVERSATIONS_AWS_USER_ID}`,
      'intuit_offeringid' : 'com.intuit.ebs'
    }
  };
};

const _extractUniversalId = function (paramsString) {
  const params = paramsString.split('&');

  // Ignore all other params besides universalId
  for (let i = 0; i < params.length; i++) {
    const keyVal = params[i].split('=');
    const key = keyVal[0];
    const value = keyVal[1] || '';

    if (key === 'universalId') {
      return value;
    }
  }

  return '';
};

const _getConversation = function (universalId) {

  const convoServiceEndpoint = `${process.env.REACT_APP_CONVERSATIONS_BASE_SERVICE_URL}/${universalId}`;
  const convoServiceHeaders = _createConvoServiceHeaders();

  return axios.get(convoServiceEndpoint, convoServiceHeaders);
};

const _parseStringToBoolean = function (rawBoolean, logger) {

  // Check if truthy; if so, then evaluate as string
  if (rawBoolean && rawBoolean === 'true') {
    return true;
  }
  else if (rawBoolean && rawBoolean === 'false') {
    return false;
  }
  // rawBoolean does exist, but it's an invalid value, default to false
  else if (rawBoolean) {

    logger.warning('WARN_standalone_shell_parse_boolean', `getConversationParamsUtil.js :: getConversationParams() :: _parseStringtoBoolean() :: Boolean should be 'true' or 'false', was instead: ${rawBoolean}`);
    return false;
  }

  // rawBoolean doesn't exist, default to false
  return false;
};

/**
 * Handles getting parameters for widget look & feel via Conversations GET call.
 * These configurations will have a default fallback look & feel for when params
 * are not passed.
 * UniversalId is derived from URL query string params; used in the GET call to 
 * specify which conversation to return back
 * @param onError callback function to show error splash and deliver message (if
 *                in preprod) when GET fails
 */
export default async function getConversationParams(onError, logger) {
  const search = window.location.search;
  // slice(1) to ignore leading question mark
  const universalId = _extractUniversalId(search.slice(1));

  if (!universalId) {
    logger.error('EXCEPTION_standalone_shell_get_conversation', `getConversationParamsUtil.js :: getConversationParams() :: No universalId found in browser. Aborting.`);
    onError(new Error('UniversalId not provided or was null'));
    return {
      chatParams: {},
      standAloneChatParams: {}
    };
  }

  logger.addStickyData('universalId', universalId);

  return _getConversation(universalId, onError)
    .then((res) => {
      const derivedParams = res.data.chatDetails;
      logger.debug('standalone_shell_chat_details', 
        'getConversationParamsUtil.js :: getConversationParams() :: _getConversation().then() :: derivedParams from chatDetails (see messageJSON)',
        derivedParams);

      // TODO: Deprecate this inside the widget
      const standAloneChatParams = {};

      // TODO: Fix the default configs here
      const chatParams = {
        universalId: universalId,
        chatTopic: derivedParams['chatTopic'] || '',
        agentChatBackgroundColor: derivedParams['agentBackgroundMessageColor'] || '#0097e6',
        agentChatFontColor: derivedParams['agentFontColor'] || '#FFFFFF',
        agentNameColor: derivedParams['agentNameColor'] || '#393a3d',
        agentTimeStampColor: derivedParams['agentTimeStampColor'] || '#393a3d',
        customerChatBackgroundColor: derivedParams['customerBackgroundMessageColor'] || '#055393',
        customerChatFontColor: derivedParams['customerFontColor'] || '#FFFFFF',
        customerNameColor: derivedParams['customerNameColor'] || '#393a3d',
        customerTimeStampColor: derivedParams['customerTimeStampColor'] || '#393a3d',
        hideHeader: _parseStringToBoolean(derivedParams['hideHeader'], logger),
        headerLogoUrl: derivedParams['headerLogoUrl'] || '',
        headerBackgroundColor: derivedParams['background'] || '#0077c5',
        hideFooter: _parseStringToBoolean(derivedParams['hideFooter'], logger),
        hideExitBtn: _parseStringToBoolean(derivedParams['hideExitBtn'], logger),
        hidePrintIcon: _parseStringToBoolean(derivedParams['hidePrintIcon'], logger),
        hideChatTail: _parseStringToBoolean(derivedParams['hideChatTail'], logger),
        hideChatBubbleHeader: _parseStringToBoolean(derivedParams['hideBubbleHeader'], logger),
        hideParticipantName: _parseStringToBoolean(derivedParams['hideParticipantName'], logger),
        hideTimeStamp: _parseStringToBoolean(derivedParams['hideTimeStamp'], logger),
        hideSystemMessages: _parseStringToBoolean(derivedParams['hideSystemMessages'], logger),
        hidePrintHistory: _parseStringToBoolean(derivedParams['hidePrintHistory'], logger),
        systemMessageColor: derivedParams['systemMessageColor'] || '#393a3d'
      };

      // Don't log chatTopic as it may have PII
      const chatParamsToLog = Object.assign({}, chatParams);
      delete chatParamsToLog.chatTopic;
      logger.debug('standalone_shell_chat_params', 
        'getConversationParamsUtil.js :: getConversationParams() :: _getConversation().then() :: chatParams (see messageJSON)',
        chatParamsToLog);

      return {
        chatParams,
        standAloneChatParams
      };
    })
    .catch((err) => {
      logger.error('EXCEPTION_standalone_shell_get_conversation', 
        'getConversationParamsUtil.js :: getConversationParams() :: _getConversation().catch() :: error making axios call to Conversations (see messageJSON',
        err);
      onError(err);
      return null;
    });
};
